import { BackendSocket } from '../../hooks/use-socket';
import { SubscriberContext } from '../../hooks/use-backend';
import { BingoJackpotWinnerMessage } from '../../types/bingo-events/in/backend/jackpot-winner-message';
import { jackpotWinner, meta } from '../../stores/backend';

export const onJackpotWinnerMessage = (
    socket: BackendSocket,
    { payload }: SubscriberContext
) => {
    const callback = (data: BingoJackpotWinnerMessage) => {
        // GameServer sends a single message per jackpot win with every winner's share.
        jackpotWinner.set(data);
        meta.modals.jackpot.set(true);
        // The won jackpot resets its pool, so the next game's value is stale.
        void payload.refreshNextJackpot();
    };

    socket.on('bingo:JackpotWinnerMessage', callback);

    return () => {
        socket.off('bingo:JackpotWinnerMessage', callback);
    };
};
